import { format } from 'date-fns';
import { toTitleCase } from 'utils/shared/toTitleCase';
import CoachBadge from 'svg/CoachBadge';
import Location from 'svg/Location';
import { UpcomingLessonCardProps } from 'screens/PlayerLoggedInScreen/props';
import LessonBadge from 'components/tournaments/LessonBadge';

const DEFAULT_GROUP_IMAGE = '/images/app/default_group_image.png';

const UpcomingLessonCard: React.FC<UpcomingLessonCardProps> = ({ lesson, onClick }) => {
  const participantLimit = lesson?.participantLimit || 0;
  const participantCount = lesson?.participants.length;
  const spotsLeft = participantLimit - participantCount;

  return (
    <div onClick={() => onClick(lesson)} className="cursor-pointer">
      <span className="typography-product-text-card-desktop max-sm:typography-product-text-card-mobile">
        {format(new Date(lesson?.startDateTime), 'EEE MMM d, HH:mm')} -{' '}
        {format(new Date(lesson?.endDateTime), 'HH:mm')}
      </span>
      <div className="mt-ds-md flex gap-ds-md  max-sm:mt-ds-sm">
        <img
          src={lesson?.ownerProfile?.profileImageProviderUrl || DEFAULT_GROUP_IMAGE}
          className="h-[5.5rem] w-[5.5rem] shrink-0 rounded-lg object-cover object-top"
          alt="lesson-image"
        />
        <div className="flex min-w-0 flex-col">
          <div className="flex items-center gap-2">
            <LessonBadge size="sm" label={toTitleCase(lesson.sport)} variant={lesson.type} />
            <span className="typography-product-button-label-small text-gray-600">
              {spotsLeft > 0 ? `${spotsLeft} spots left` : 'full'}
            </span>
          </div>
          <h6 className="typography-product-card-title-desktop max-sm:typography-product-card-title-mobile mt-1">
            {lesson.title}
          </h6>
          <div className="mt-1 flex items-start gap-1 ">
            <Location className="h-4 w-4 flex-shrink-0 text-color-bg-lightmode-icon dark:text-color-bg-darkmode-icon " />
            <span className="typography-product-text-card-desktop max-sm:typography-product-text-card-mobile truncate text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
              {lesson?.userCustomCourt?.fullAddress ||
                lesson?.venue?.addressString ||
                'Address not available'}
            </span>
          </div>
          <div className="mt-1 flex items-center gap-1">
            <CoachBadge className="h-4 w-4 flex-shrink-0 text-color-bg-lightmode-icon dark:text-color-bg-darkmode-icon " />
            <span className="max-sm:typography-product-text-card-mobile typography-product-text-card-desktop dark:text-color-text-darkmode-secondaryF text-color-text-lightmode-secondary">
              {toTitleCase(lesson?.ownerProfile?.fullName ?? 'Title not available')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpcomingLessonCard;
